import { PU_PRACTICE } from '../patient-urgency/mockData';
import type { PuPatient } from '../patient-urgency/types';
import type { PiPublicPageData } from './types';

/** Gate patient — same DOB as treatment demo (`1979-03-15`). */
export const PI_PUBLIC_GATE_PATIENT: PuPatient = {
  preferredName: 'John',
  fullName: 'John Smithson',
  surname: 'Smithson',
  initials: 'JS',
  dobMatch: '1979-03-15',
  unscheduledValue: 2000,
  insurance: {
    carrier: 'Delta Dental PPO',
    annualMax: 2000,
    used: 500,
    remaining: 1500,
    resetDate: 'January 1, 2027',
    resetsInDays: 40,
    familyPool: false,
  },
};

export const PI_PUBLIC_PAGE_DATA: PiPublicPageData = {
  patient: PI_PUBLIC_GATE_PATIENT,
  practice: PU_PRACTICE,
  profile: {
    name: 'John Smithson',
    avatar: '/avatar.jpg',
    statusLabel: 'Active Treatment',
    nextAppointment: 'Monday, Dec 12, 2:00 PM',
    nextAppointmentDetail: 'IPR & Attachment check',
    provider: 'Dr. John Smith, DDS',
    currentTray: 7,
    totalTrays: 24,
    daysLeft: 3,
    switchTrayDate: 'Friday, Dec 20',
    totalCost: '$2,000',
    remainingBalance: '$1500',
    progressPct: 33,
    insurancePaid: '$2200',
    patientPaid: '$2200',
    balanceDue: '$2200',
    pendingClaims: '1 claim pending',
    paymentPlanNote:
      'Your next installment of $250 will be automatically processed on Nov 15th via the card on file.',
  },
  smileBefore: '/avatar.jpg',
  smileAfter: '/avatar.jpg',
  clincheckPoster: '/avatar.jpg',
  articles: [
    {
      id: 'a1',
      image: '/avatar.jpg',
      imageAlt: 'Cleaning Aligners',
      title: 'Cleaning Aligners',
      description: 'Best practices for keeping your trays crystal clear and odor-free.',
    },
    {
      id: 'a2',
      image: '/avatar.jpg',
      imageAlt: 'Article',
      title: 'Article Title',
      description: 'Article description goes here.',
    },
    {
      id: 'a3',
      image: '/avatar.jpg',
      imageAlt: 'Article',
      title: 'Article Title',
      description: 'Article description goes here.',
    },
    {
      id: 'a4',
      image: '/avatar.jpg',
      imageAlt: 'Article',
      title: 'Article Title',
      description: 'Article description goes here.',
    },
  ],
  visits: [
    { id: 'v1', title: 'Tray 1-6 Checkup', date: 'Sep 12, 2023' },
    { id: 'v2', title: 'Initial Consultation', date: 'Aug 01, 2023' },
  ],
};
